import { AppDomainConstant } from "../app-domain.constant";

export class ParametrizacionesAPIConstant {

    static readonly BASE_URL: string = 'api/v1/parametrizaciones/';
    static readonly TABLA_PARAMETRICA: string = 'tabla-parametrica';
    static readonly BASE_URL_RESOURCES: string = "api/v1/resource-management/"

    static readonly MOTIVO_ESTADO: string = ParametrizacionesAPIConstant.BASE_URL + 'motivo-estado';    
    static readonly ES_DESARROLLO: boolean = 
        AppDomainConstant.IS_DEVELOPMENT;


    static readonly URL_GET_PARAMETRIZACIONES: string =
        AppDomainConstant.URI_GATEWAY +
        this.BASE_URL +
        this.TABLA_PARAMETRICA;

    static readonly URL_TABLA_PARAMETRICA: string =
        AppDomainConstant.URI_GATEWAY +
        this.BASE_URL;

    static readonly URL_LOAD_RESOURCE: string =
        AppDomainConstant.URI_GATEWAY +
        this.BASE_URL_RESOURCES + 'firma-digital';

    static readonly URL_MOTIVO_ESTADO: string =
        AppDomainConstant.URI_GATEWAY +
        ParametrizacionesAPIConstant.MOTIVO_ESTADO;    


}